import React from 'react';
import { Card, Column, Typography } from '@tempmee/react';

/**
 * Holds the Locations tab's place until the identity's locations are listed
 * (a later GOTU-7482 task). Asks for nothing.
 */
export const LocationsTab = () => (
  <Card outline>
    <Column px={5} py={4} gap={2}>
      <Typography variant="h6" as="h1">
        Locations
      </Typography>
      <Typography variant="body1">Locations will be listed here in an upcoming release.</Typography>
    </Column>
  </Card>
);

export default LocationsTab;
